import AuthLayout from "layouts/AuthLayout";
import type { ResetPasswordModel } from "pages/accounts-onboarding/models";
import { ResetPasswordPage } from "pages/accounts-onboarding/reset-password";
import React from "react";

const ResetPasswordRoute = () => {
	const initialValues: ResetPasswordModel = {
		newPassword: "",
		confirmPassword: ""
	};

	return (
		<AuthLayout>
			<ResetPasswordPage initialValues={initialValues} />
		</AuthLayout>
	);
};

export default ResetPasswordRoute;
